/* Original template shell interactions, using server-rendered Shopify data. */
'use strict';
(() => {
  const shopToggle = document.querySelector('.nav-shop-toggle');
  const shopMenu = document.getElementById('shop-menu');
  const closeShop = () => {
    shopToggle?.setAttribute('aria-expanded', 'false');
    if (shopMenu) shopMenu.hidden = true;
  };
  shopToggle?.addEventListener('click', () => {
    const open = shopToggle.getAttribute('aria-expanded') !== 'true';
    shopToggle.setAttribute('aria-expanded', String(open));
    shopMenu.hidden = !open;
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.nav-shop')) closeShop();
  });
  const menuButton = document.querySelector('.menu-button');
  const mobileNav = document.getElementById('mobile-nav');
  const closeMobile = () => {
    if (mobileNav) mobileNav.hidden = true;
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
  };
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    mobileNav.hidden = !open;
  });
  mobileNav?.addEventListener('click', event => {
    if (event.target.closest('a')) closeMobile();
  });
  matchMedia('(min-width: 961px)').addEventListener('change', event => {
    if (event.matches) closeMobile();
  });
  let lastTrigger;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open);
      if (!(dialog instanceof HTMLDialogElement)) return;
      lastTrigger = opener;
      dialog.showModal();
      if (dialog.id === 'search-dialog') document.getElementById('search-input')?.focus();
    }
    const closer = event.target.closest('[data-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => lastTrigger?.focus());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (shopToggle?.getAttribute('aria-expanded') === 'true') {
      closeShop();
      shopToggle.focus();
    }
    if (mobileNav && !mobileNav.hidden) {
      closeMobile();
      menuButton.focus();
    }
  });
})();
